module.exports = __webpack_public_path__ + "static/media/techforce_marco_cropped.8138d8d8.jpg";